(function () {
  if (!('IntersectionObserver' in window)) return;
  var style = document.createElement('style');
  style.textContent = '.hm-reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.7s cubic-bezier(0.16,1,0.3,1), transform 0.7s cubic-bezier(0.16,1,0.3,1); } .hm-reveal.hm-revealed { opacity: 1; transform: translateY(0); }';
  document.head.appendChild(style);

  function tag() {
    var targets = document.querySelectorAll('#MainContent .shopify-section, main .shopify-section');
    targets.forEach(function (el) {
      if (!el.classList.contains('hm-reveal') && !el.classList.contains('hm-revealed')) {
        el.classList.add('hm-reveal');
      }
    });
    return targets.length;
  }

  function observe() {
    var count = tag();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hm-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.hm-reveal').forEach(function (el) { obs.observe(el); });

    // Filet de securite : si au bout de 2s rien n'a ete detecte (probleme de structure),
    // on affiche tout normalement plutot que de laisser des sections invisibles.
    setTimeout(function () {
      document.querySelectorAll('.hm-reveal:not(.hm-revealed)').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight) el.classList.add('hm-revealed');
      });
    }, 300);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    observe();
  } else {
    document.addEventListener('DOMContentLoaded', observe);
  }
  window.addEventListener('load', function () { tag(); });
})();
